const AgentFooterStyles = {
  footerContainer: {
    position: "fixed",
    bottom: "0",
    width: "100%",
    height: "52px",
    backgroundColor: "var(--alice-blue)",
    borderTop: " 1px solid var( --silver-grey)",
    padding: "0px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: 998,
    "@media(max-width: 780px)": {
      position: "static",
      bottom: "unset",
      width: "auto",
      height: "104px",
      flexDirection: "column",
      justifyContent: "center",
      gap: "15px",
    },
  },
  copyRights: {
    fontFamily: "var(--font-noto-sans)",
    fontSize: "var(--font-size-16)",
    fontWeight: "var(--font-weight-400)",
    textAlign: " left",
    opacity: "75%",
    "@media(max-width: 767px)": {
      width: "100%",
      marginRight: 0,
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
  },
  footerItems: {
    width: "30%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "2rem",
    marginRight: 2,
    "@media(max-width: 767px)": {
      width: "100%",
      marginRight: 0,
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    "@media(min-width: 768px) and (max-width:1200px)": {
      width: "100%",
      paddingX: 10,
    },
  },
  rightText: {
    fontFamily: "var(--font-noto-sans)",
    fontSize: "var(--font-size-16)",
    fontWeight: "var(--font-weight-400)",
  },
};

export default AgentFooterStyles;
